import React from "react";

const GlossaryCard = ({ term, index, copiedTerm, setCopiedTerm }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(term.definition);
    setCopiedTerm(term.definition);
    setTimeout(() => setCopiedTerm(null), 2000);
  };

  return (
    <div
      className="glossary-card"
      style={{ animationDelay: `${index * 0.05}s` }}
      onClick={handleCopy}
    >
      <div className="card-content">
        <h5 className="card-title">{term.word}</h5>
        <p className="card-definition">{term.definition}</p>
        <span className="copy-hint">
          {copiedTerm === term.definition ? "Скопировано!" : "Нажмите, чтобы скопировать"}
        </span>
      </div>
    </div>
  );
};

export default GlossaryCard;